import Header from "../Header/header";
import Banner from "../Banner/banner";
import BrandSlider from "../Brand/brand";
import About from "../About/about";
import Philosophy from "../Philosophy/philosophy";
import Work from "../Work/work";
import Contact from "../Contact/contact";
import Footer from "../Footer/footer";
import Intrested from "../Intrested/intrested";

/*--------------------
* Twilight Tier — page assembly
----------------------*/
export default function Krinky() {
  return (
    <>
      <Header />
      <main className="wrapper">
        <Banner />
        <BrandSlider />
        <About />
        <Philosophy />
        <Work />
        <Intrested />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
